export const CREATE_RESOURCE_INIT = "CREATE_RESOURCE_INIT";
export const CREATE_RESOURCE_SUCCESS = "CREATE_RESOURCE_SUCCESS";
export const CREATE_RESOURCE_FAILED = "CREATE_RESOURCE_FAILED";
export const GET_RESOURCE_ANALYTICS_INIT = "GET_RESOURCE_ANALYTICS_INIT";
export const GET_RESOURCE_ANALYTICS_SUCCESS = "GET_RESOURCE_ANALYTICS_SUCCESS";
export const GET_RESOURCE_ANALYTICS_FAILED = "GET_RESOURCE_ANALYTICS_FAILED";
export const GET_TOTAL_RESOURCES_INIT = "GET_TOTAL_RESOURCES_INIT";
export const GET_TOTAL_RESOURCES_SUCCESS = "GET_TOTAL_RESOURCES_SUCCESS";
export const GET_TOTAL_RESOURCES_FAILED = "GET_TOTAL_RESOURCES_FAILED";
export const GET_RESOURCES_BY_ROLES_INIT = "GET_RESOURCES_BY_ROLES_INIT";
export const GET_RESOURCES_BY_ROLES_SUCCESS = "GET_RESOURCES_BY_ROLES_SUCCESS";
export const GET_RESOURCES_BY_ROLES_FAILED = "GET_RESOURCES_BY_ROLES_FAILED";
export const GET_RESOURCE_DETAILS_BY_ID_INIT =
  "GET_RESOURCE_DETAILS_BY_ID_INIT";
export const GET_RESOURCE_DETAILS_BY_ID_SUCCESS =
  "GET_RESOURCE_DETAILS_BY_ID_SUCCESS";
export const GET_RESOURCE_DETAILS_BY_ID_FAILED =
  "GET_RESOURCE_DETAILS_BY_ID_FAILED";
export const UPDATE_RESOURCE_DETAILS_INIT = "UPDATE_RESOURCE_DETAILS_INIT";
export const UPDATE_RESOURCE_DETAILS_SUCCESS =
  "UPDATE_RESOURCE_DETAILS_SUCCESS";
export const UPDATE_RESOURCE_DETAILS_FAILED = "UPDATE_RESOURCE_DETAILS_FAILED";
export const GET_RESOURCE_ALLOCATION_MATRIX_INIT =
  "GET_RESOURCE_ALLOCATION_MATRIX_INIT";
export const GET_RESOURCE_ALLOCATION_MATRIX_SUCCESS =
  "GET_RESOURCE_ALLOCATION_MATRIX_SUCCESS";
export const GET_RESOURCE_ALLOCATION_MATRIX_FAILED =
  "GET_RESOURCE_ALLOCATION_MATRIX_FAILED";
export const GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS =
  "GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS";
export const GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS_SUCCESS =
  "GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS_SUCCESS";
export const GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS_FAILED =
  "GET_RESOURCE_ALLOCATION_MATRIX_DATA_LIMITS_FAILED";
export const UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE =
  "UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE";
export const UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE_SUCCESS =
  "UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE_SUCCESS";
export const UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE_FAILED =
  "UPDATE_RESOURCE_ALLOCATION_MATRIX_DATA_FTE_FAILED";
export const GET_UTILIZATION_LEVEL_INIT = "GET_UTILIZATION_LEVEL_INIT";
export const GET_UTILIZATION_LEVEL_SUCCESS = "GET_UTILIZATION_LEVEL_SUCCESS";
export const GET_UTILIZATION_LEVEL_FAILED = "GET_UTILIZATION_LEVEL_FAILED";
export const CLEAR_RM_LANDING_DATA = "CLEAR_RM_LANDING_DATA";
export const GET_UTILIZATION_PERCENTAGE_INIT =
  "GET_UTILIZATION_PERCENTAGE_INIT";
export const GET_UTILIZATION_PERCENTAGE_SUCCESS =
  "GET_UTILIZATION_PERCENTAGE_SUCCESS";
export const GET_UTILIZATION_PERCENTAGE_FAILED =
  "GET_UTILIZATION_PERCENTAGE_FAILED";
export const GET_PROJECT_LIST_INIT = "GET_PROJECT_LIST_INIT";
export const GET_PROJECT_LIST_SUCCESS = "GET_PROJECT_LIST_SUCCESS";
export const GET_PROJECT_LIST_FAILED = "GET_PROJECT_LIST_FAILED";
export const GET_RESOURCES_BY_LOCATION_INIT = "GET_RESOURCES_BY_LOCATION_INIT";
export const GET_RESOURCES_BY_LOCATION_SUCCESS =
  "GET_RESOURCES_BY_LOCATION_SUCCESS";
export const GET_RESOURCES_BY_LOCATION_FAILED =
  "GET_RESOURCES_BY_LOCATION_FAILED";
export const GET_UTILIZATION_GRAPH_BY_ID_INIT =
  "GET_UTILIZATION_GRAPH_BY_ID_INIT";
export const GET_UTILIZATION_GRAPH_BY_ID_SUCCESS =
  "GET_UTILIZATION_GRAPH_BY_ID_SUCCESS";
export const GET_UTILIZATION_GRAPH_BY_ID_FAILED =
  "GET_UTILIZATION_GRAPH_BY_ID_FAILED";
export const GET_INHOUSE_RESOURCE_DETAILS_INIT =
  "GET_INHOUSE_RESOURCE_DETAILS_INIT";
export const GET_INHOUSE_RESOURCE_DETAILS_SUCCESS =
  "GET_INHOUSE_RESOURCE_DETAILS_SUCCESS";
export const GET_INHOUSE_RESOURCE_DETAILS_FAILED =
  "GET_INHOUSE_RESOURCE_DETAILS_FAILED";
export const GET_VENDOR_RESOURCE_DETAILS_INIT =
  "GET_VENDOR_RESOURCE_DETAILS_INIT";
export const GET_VENDOR_RESOURCE_DETAILS_SUCCESS =
  "GET_VENDOR_RESOURCE_DETAILS_SUCCESS";
export const GET_VENDOR_RESOURCE_DETAILS_FAILED =
  "GET_VENDOR_RESOURCE_DETAILS_FAILED";
export const GET_RESOURCES_BY_DEPARTMENT_INIT =
  "GET_RESOURCES_BY_DEPARTMENT_INIT";
export const GET_RESOURCES_BY_DEPARTMENT_SUCCESS =
  "GET_RESOURCES_BY_DEPARTMENT_SUCCESS";
export const GET_RESOURCES_BY_DEPARTMENT_FAILED =
  "GET_RESOURCES_BY_DEPARTMENT_FAILED";
export const GET_RESOURCES_BY_PROJECT_INIT = "GET_RESOURCES_BY_PROJECT_INIT";
export const GET_RESOURCES_BY_PROJECT_SUCCESS =
  "GET_RESOURCES_BY_PROJECT_SUCCESS";
export const GET_RESOURCES_BY_PROJECT_FAILED =
  "GET_RESOURCES_BY_PROJECT_FAILED";
export const GET_RESOURCES_BY_UTILIZATION_INIT =
  "GET_RESOURCES_BY_UTILIZATION_INIT";
export const GET_RESOURCES_BY_UTILIZATION_SUCCESS =
  "GET_RESOURCES_BY_UTILIZATION_SUCCESS";
export const GET_RESOURCES_BY_UTILIZATION_FAILED =
  "GET_RESOURCES_BY_UTILIZATION_FAILED";
export const GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_INIT =
  "GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_INIT";
export const GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_SUCCESS =
  "GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_SUCCESS";
export const GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_FAILED =
  "GET_AGGREGATE_RESOURCE_ALLOCATION_MATRIX_FAILED";
export const GET_ALLOCATION_BY_MAPID_INIT = "GET_ALLOCATION_BY_MAPID_INIT";
export const GET_ALLOCATION_BY_MAPID_SUCCESS =
  "GET_ALLOCATION_BY_MAPID_SUCCESS";
export const GET_ALLOCATION_BY_MAPID_FAILED = "GET_ALLOCATION_BY_MAPID_FAILED";
export const GET_RESOURCES_BY_PROJECT_OWNER_INIT =
  "GET_RESOURCES_BY_PROJECT_OWNER_INIT";
export const GET_RESOURCES_BY_PROJECT_OWNER_SUCCESS =
  "GET_RESOURCES_BY_PROJECT_OWNER_SUCCESS";
export const GET_RESOURCES_BY_PROJECT_OWNER_FAILED =
  "GET_RESOURCES_BY_PROJECT_OWNER_FAILED";
export const GET_RESOURCE_ALL_ALLOCATIONS_CHART_INIT =
  "GET_RESOURCE_ALL_ALLOCATIONS_CHART_INIT";
export const GET_RESOURCE_ALL_ALLOCATIONS_CHART_SUCCESS =
  "GET_RESOURCE_ALL_ALLOCATIONS_CHART_SUCCESS";
export const GET_RESOURCE_ALL_ALLOCATIONS_CHART_FAILED =
  "GET_RESOURCE_ALL_ALLOCATIONS_CHART_FAILED";
export const UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_INIT =
  "UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_INIT";
export const UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_SUCCESS =
  "UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_SUCCESS";
export const UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_FAILED =
  "UPDATE_RESOURCE_ALL_ALLOCATIONS_CHART_FAILED";
export const DOWNLOAD_CREATE_RESOURCE_EXCEL_INIT =
  "DOWNLOAD_CREATE_RESOURCE_EXCEL_INIT";
export const DOWNLOAD_CREATE_RESOURCE_EXCEL_SUCCESS =
  "DOWNLOAD_CREATE_RESOURCE_EXCEL_SUCCESS";
export const DOWNLOAD_CREATE_RESOURCE_EXCEL_FAILED =
  "DOWNLOAD_CREATE_RESOURCE_EXCEL_FAILED";
export const UPLOAD_RESOURCE_INIT = "UPLOAD_RESOURCE_INIT";
export const UPLOAD_RESOURCE_SUCCESS = "UPLOAD_RESOURCE_SUCCESS";
export const UPLOAD_RESOURCE_FAILED = "UPLOAD_RESOURCE_FAILED";
export const ALL_RESOURCES_GANTT_CHART_INIT = "ALL_RESOURCES_GANTT_CHART_INIT";
export const ALL_RESOURCES_GANTT_CHART_SUCCESS =
  "ALL_RESOURCES_GANTT_CHART_SUCCESS";
export const ALL_RESOURCES_GANTT_CHART_FAILED =
  "ALL_RESOURCES_GANTT_CHART_FAILED";
export const GET_DEPARTMENTS_RESOURCES_INIT = "GET_DEPARTMENTS_RESOURCES_INIT";
export const GET_DEPARTMENTS_RESOURCES_SUCCESS =
  "GET_DEPARTMENTS_RESOURCES_SUCCESS";
export const GET_DEPARTMENTS_RESOURCES_FAILED =
  "GET_DEPARTMENTS_RESOURCES_FAILED";
export const GET_RESOURCE_HIERARCHY_INIT = "GET_RESOURCE_HIERARCHY_INIT";
export const GET_RESOURCE_HIERARCHY_SUCCESS = "GET_RESOURCE_HIERARCHY_SUCCESS";
export const GET_RESOURCE_HIERARCHY_FAILED = "GET_RESOURCE_HIERARCHY_FAILED";
export const GET_SPECIFIC_RESOURCE_HIERARCHY_INIT =
  "GET_SPECIFIC_RESOURCE_HIERARCHY_INIT";
export const GET_SPECIFIC_RESOURCE_HIERARCHY_SUCCESS =
  "GET_SPECIFIC_RESOURCE_HIERARCHY_SUCCESS";
export const GET_SPECIFIC_RESOURCE_HIERARCHY_FAILED =
  "GET_SPECIFIC_RESOURCE_HIERARCHY_FAILED";
export const DOWNLOAD_RESOURCE_ANALYTICS_INIT =
  "DOWNLOAD_RESOURCE_ANALYTICS_INIT";
export const DOWNLOAD_RESOURCE_ANALYTICS_SUCCESS =
  "DOWNLOAD_RESOURCE_ANALYTICS_SUCCESS";
export const DOWNLOAD_RESOURCE_ANALYTICS_FAILED =
  "DOWNLOAD_RESOURCE_ANALYTICS_FAILED";
export const DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_INIT =
  "DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_INIT";
export const DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_SUCCESS =
  "DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_SUCCESS";
export const DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_FAILED =
  "DOWNLOAD_FILTERED_RESOURCE_ANALYTICS_FAILED";
export const GET_DEPARTMENTS_INIT = "GET_DEPARTMENTS_INIT";
export const GET_DEPARTMENTS_SUCCESS = "GET_DEPARTMENTS_SUCCESS";
export const GET_DEPARTMENTS_FAILED = "GET_DEPARTMENTS_FAILED";
export const GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_INIT =
  "GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_INIT";
export const GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_SUCCESS =
  "GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_SUCCESS";
export const GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_FAILED =
  "GET_DEPARTMENT_ALL_RESOURCES_ALLOCATIONS_FAILED";
export const GET_SWAP_RESOURCES_ELIGIBLE_LIST_INIT =
  "GET_SWAP_RESOURCES_ELIGIBLE_LIST_INIT";
export const GET_SWAP_RESOURCES_ELIGIBLE_LIST_SUCCESS =
  "GET_SWAP_RESOURCES_ELIGIBLE_LIST_SUCCESS";
export const GET_SWAP_RESOURCES_ELIGIBLE_LIST_FAILED =
  "GET_SWAP_RESOURCES_ELIGIBLE_LIST_FAILED";
export const SWAP_RESOURCE_INIT = "SWAP_RESOURCE_INIT";
export const SWAP_RESOURCE_SUCCESS = "SWAP_RESOURCE_SUCCESS";
export const SWAP_RESOURCE_FAILED = "SWAP_RESOURCE_FAILED";
export const GET_SEARCH_FILTERS_FOR_UNNAMED_INIT =
  "GET_SEARCH_FILTERS_FOR_UNNAMED_INIT";
export const GET_SEARCH_FILTERS_FOR_UNNAMED_SUCCESS =
  "GET_SEARCH_FILTERS_FOR_UNNAMED_SUCCESS";
export const GET_SEARCH_FILTERS_FOR_UNNAMED_FAILED =
  "GET_SEARCH_FILTERS_FOR_UNNAMED_FAILED";
export const ASSIGN_RESOURCE_TO_UNNAMED_INIT =
  "ASSIGN_RESOURCE_TO_UNNAMED_INIT";
export const ASSIGN_RESOURCE_TO_UNNAMED_SUCCESS =
  "ASSIGN_RESOURCE_TO_UNNAMED_SUCCESS";
export const ASSIGN_RESOURCE_TO_UNNAMED_FAILED =
  "ASSIGN_RESOURCE_TO_UNNAMED_FAILED";
export const GET_RESOURCE_REQUESTS_INIT = "GET_RESOURCE_REQUESTS_INIT";
export const GET_RESOURCE_REQUESTS_SUCCESS = "GET_RESOURCE_REQUESTS_SUCCESS";
export const GET_RESOURCE_REQUESTS_FAILED = "GET_RESOURCE_REQUESTS_FAILED";
export const GET_PROJECT_REQUESTS_INIT = "GET_PROJECT_REQUESTS_INIT";
export const GET_PROJECT_REQUESTS_SUCCESS = "GET_PROJECT_REQUESTS_SUCCESS";
export const GET_PROJECT_REQUESTS_FAILED = "GET_PROJECT_REQUESTS_FAILED";
export const GET_ALLOCATION_MATRIX_ALL_RESOURCES_INIT =
  "GET_ALLOCATION_MATRIX_ALL_RESOURCES_INIT";
export const GET_ALLOCATION_MATRIX_ALL_RESOURCES_SUCCESS =
  "GET_ALLOCATION_MATRIX_ALL_RESOURCES_SUCCESS";
export const GET_ALLOCATION_MATRIX_ALL_RESOURCES_FAILED =
  "GET_ALLOCATION_MATRIX_ALL_RESOURCES_FAILED";
export const GET_PROFILE_INIT = "GET_PROFILE_INIT";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAILED = "GET_PROFILE_FAILED";
export const GET_PROJECT_NOTIFICATION_COUNT_INIT =
  "GET_PROJECT_NOTIFICATION_COUNT_INIT";
export const GET_PROJECT_NOTIFICATION_COUNT_SUCCESS =
  "GET_PROJECT_NOTIFICATION_COUNT_SUCCESS";
export const GET_PROJECT_NOTIFICATION_COUNT_FAILED =
  "GET_PROJECT_NOTIFICATION_COUNT_FAILED";
export const GET_NOTIFICATION_VIEWED_INIT = "GET_NOTIFICATION_VIEWED_INIT";
export const GET_NOTIFICATION_VIEWED_SUCCESS =
  "GET_NOTIFICATION_VIEWED_SUCCESS";
export const GET_NOTIFICATION_VIEWED_FAILED = "GET_NOTIFICATION_VIEWED_FAILED";
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";
export const CLEAR_GANTT_CHART_BY_DEPARTMENT =
  "CLEAR_GANTT_CHART_BY_DEPARTMENT";
export const CLEAR_GANTT_CHART_BY_NAMED = "CLEAR_GANTT_CHART_BY_NAMED";
export const COMPLIANCE_REPORT_RESOURCE_INIT =
  "COMPLIANCE_REPORT_RESOURCE_INIT";
export const COMPLIANCE_REPORT_RESOURCE_SUCCESS =
  "COMPLIANCE_REPORT_RESOURCE_SUCCESS";
export const COMPLIANCE_REPORT_RESOURCE_FAILED =
  "COMPLIANCE_REPORT_RESOURCE_FAILED";
export const DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_INIT =
  "DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_INIT";
export const DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_SUCCESS =
  "DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_SUCCESS";
export const DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_FAILED =
  "DOWNLOAD_COMPLIANCE_REPORT_RESOURCE_FAILED";
export const ACCEPT_COMPLETE_RESOURCE_INIT = "ACCEPT_COMPLETE_RESOURCE_INIT";
export const ACCEPT_COMPLETE_RESOURCE_SUCCESS =
  "ACCEPT_COMPLETE_RESOURCE_SUCCESS";
export const ACCEPT_COMPLETE_RESOURCE_FAILED =
  "ACCEPT_COMPLETE_RESOURCE_FAILED";
export const DOWNLOAD_RESOURCE_INIT = "DOWNLOAD_RESOURCE_INIT";
export const DOWNLOAD_RESOURCE_SUCCESS = "DOWNLOAD_RESOURCE_SUCCESS";
export const DOWNLOAD_RESOURCE_FAILED = "DOWNLOAD_RESOURCE_FAILED";
export const UPDATE_RESOURCES_BY_PROJECT_INIT =
  "UPDATE_RESOURCES_BY_PROJECT_INIT";
export const UPDATE_RESOURCES_BY_PROJECT_SUCCESS =
  "UPDATE_RESOURCES_BY_PROJECT_SUCCESS";
export const UPDATE_RESOURCES_BY_PROJECT_FAILED =
  "UPDATE_RESOURCES_BY_PROJECT_FAILED";
export const GET_REQUEST_DETAILS_BY_MAPID_INIT =
  "GET_REQUEST_DETAILS_BY_MAPID_INIT";
export const GET_REQUEST_DETAILS_BY_MAPID_SUCCESS =
  "GET_REQUEST_DETAILS_BY_MAPID_SUCCESS";
export const GET_REQUEST_DETAILS_BY_MAPID_FAILED =
  "GET_REQUEST_DETAILS_BY_MAPID_FAILED";
export const REJECT_RESOURCE_INIT = "REJECT_RESOURCE_INIT";
export const REJECT_RESOURCE_SUCCESS = "REJECT_RESOURCE_SUCCESS";
export const REJECT_RESOURCE_FAILED = "REJECT_RESOURCE_FAILED";
export const ACCEPT_ALL_RESOURCE_REQUESTS_INIT =
  "ACCEPT_ALL_RESOURCE_REQUESTS_INIT";
export const ACCEPT_ALL_RESOURCE_REQUESTS_SUCCESS =
  "ACCEPT_ALL_RESOURCE_REQUESTS_SUCCESS";
export const ACCEPT_ALL_RESOURCE_REQUESTS_FAILED =
  "ACCEPT_ALL_RESOURCE_REQUESTS_FAILED";
export const ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_INIT =
  "ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_INIT";
export const ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_SUCCESS =
  "ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_SUCCESS";
export const ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_FAILED =
  "ACCEPT_ALL_RESOURCE_REQUESTS_BY_PROJECT_FAILED";
